import { createSlice } from "@reduxjs/toolkit";
import { graphicUpdateDevices } from "space/spaceSignalling";
import {
  selectCurrentCameraTrackId,
  selectCurrentMicTrackId,
} from "./devicesSlice";
import { selectMyLuid } from "./spaceMediaSlice";
// let dispatch = null;
let getState = null;
import("Store").then((module) => {
  // dispatch = module.store.dispatch;
  getState = module.store.getState;
});

const INITIAL_STATE = {
  meMic: false,
  meMicActive: false,
  meSharing: null, // "screen" or "board"
  meScreenTrackId: null,
  meCamera: false,
  meCameraActive: false,
};

export const slice = createSlice({
  name: "spaceMyMedia",
  initialState: INITIAL_STATE,
  reducers: {
    setMeMic: (state, action) => {
      state.meMic = action.payload;
    },
    setMeSharing: (state, action) => {
      state.meSharing = action.payload;
    },
    setMeScreenTrackId: (state, action) => {
      state.meScreenTrackId = action.payload;
    },
    setMeCamera: (state, action) => {
      state.meCamera = action.payload;
    },
    setMyMediaState: (state, action) => {
      state = { state, ...action.payload };
    },
    resetSpaceMyMediaSlice: (state) => INITIAL_STATE,
  },
});

export const {
  setMeMic,
  setMeSharing,
  setMeScreenTrackId,
  setMeCamera,
  setMyMediaState,
  resetSpaceMyMediaSlice,
} = slice.actions;

export const graphicUpdateMyDevices = () => {
  graphicUpdateDevices(
    selectMyLuid(getState()),
    selectCurrentMicTrackId(getState()),
    selectMeScreenTrackId(getState()) ||
      selectMeSharing(getState()) === "board",
    selectCurrentCameraTrackId(getState())
  );
};

// export const selectSilent = (state) => state.spaceMyMedia.silent;
export const selectMeMic = (state) => state.spaceMyMedia.meMic;
export const selectMeSharing = (state) => state.spaceMyMedia.meSharing;
export const selectMeScreenTrackId = (state) =>
  state.spaceMyMedia.meScreenTrackId;
export const selectMeCamera = (state) => state.spaceMyMedia.meCamera;

export default slice.reducer;
